module.exports = __webpack_public_path__ + "static/media/portfolio4.a023f0e0.jpg";